import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

interface ApiResponse {
  success: boolean;
}

const useNotifyAdmin = () => {
  return useMutation<ApiResponse, Error, void>({
    mutationFn: async () => {
      const response = await axios.post<ApiResponse>(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/subscription/notify-admin`,
      );
      return response.data;
    },
  });
};

export { useNotifyAdmin };
